import { useContext } from 'react'

import translationContext from '../contexts/Translation'
import moduleTranslationContext from '../contexts/ModuleTranslation'

const useTranslate = () => {
  const globalTranslate = useContext(translationContext)
  const moduleTranslate = useContext(moduleTranslationContext)

  const translate = (path, opts = {}) => {
    const { replacements, expectMissing } = opts
    let translation
    // Search in module level translation context first if moduleTranslate is used
    translation = moduleTranslate && moduleTranslate(path, { expectMissing })
    // If not found in module level, continue searching in global
    if (!translation) {
      translation = globalTranslate(path, { expectMissing })
    }
    // if replacement is defined, handle replacements
    if (replacements && translation !== undefined) {
      if (typeof replacements === 'function') {
        return replacements(translation)
      }
      if (typeof replacements === 'object') {
        Object.entries(replacements).forEach((r) => {
          const [search, replacement] = r
          translation = translation.replace(`#${search}#`, replacement)
        })
        return translation
      }
    }
    return translation
  }
  return translate
}

export default useTranslate
